// extracted by mini-css-extract-plugin
module.exports = {"link":"territorialOrganizationTooltip_link__1Cxc-"};